import React, { useState } from "react";
import PropTypes from "prop-types";

import RadioDrop from "./RadioDrop";

const RadioGroup = ({ radioOptions, input }) => {
  const [selected, setSelected] = useState("");

  const handleSelect = e => {
    setSelected(e.target.value);
    input.onChange(e.target.value);
  };

  return (
    <div className="radio-drops-container">
      {radioOptions.map(radioButtonData => {
        const {
          label,
          value,
          onRadioButtonClick: handleClick,
          disabled,
        } = radioButtonData;
        return (
          <RadioDrop
            key={`${value}`}
            label={label}
            disabled={disabled}
            value={value}
            onRadioButtonSelect={handleSelect}
            onRadioButtonClick={handleClick}
            input={input}
            selected={value === selected || value === input.value}
          />
        );
      })}
    </div>
  );
};

RadioGroup.propTypes = {
  radioOptions: PropTypes.array,
  input: PropTypes.object,
};

export default RadioGroup;
